module.exports = {};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/babel-polyfill/~/core-js/modules/_iterators.js
// module id = 81uK
// module chunks = 0 3